import React, { Component } from 'react';
import axios from 'axios';

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      subject: '',
      phone: '',
      message: '',
      agree: false,
      responseMessage: '',
      responseClass: ''
    };
  }

  handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState({
      [name]: type === 'checkbox' ? checked : value
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      name: this.state.name,
      email: this.state.email,
      subject: this.state.subject,
      phone: this.state.phone,
      message: this.state.message,
    
    };

    axios.post('https://medesco.ma/mail.php', formData, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(res => {
      const successMessage = res.data.success || "✅ Votre message a bien été envoyé.";
      this.setState({
        responseMessage: successMessage,
        responseClass: 'success',
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: '',
        agree: false
      });
    })
    .catch(err => {
      const errorMessage = err.response?.data?.error || "❌ Une erreur s'est produite lors de l'envoi.";
      this.setState({
        responseMessage: errorMessage,
        responseClass: 'error'
      });
    });
  };

  render() {
    return (
      <div className="ltn__contact-message-area mb-10">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="ltn__form-box contact-form-box box-shadow white-bg">
                <h4 className="title-2">Laissez-nous un message</h4>
                <form id="contact-form" onSubmit={this.handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="input-item input-item-name ltn__custom-icon">
                        <input
                          type="text"
                          name="name"
                          placeholder="Votre nom complet"
                          value={this.state.name}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-item input-item-email ltn__custom-icon">
                        <input
                          type="email"
                          name="email"
                          placeholder="Votre adresse e-mail"
                          value={this.state.email}
                          onChange={this.handleChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="input-item input-item-subject ltn__custom-icon">
                        <input
                          className="nice-select"
                          name="subject"
                          value={this.state.subject}
                          onChange={this.handleChange}
                          required
                          placeholder="Votre sujet"
                        />
                        
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="input-item input-item-phone ltn__custom-icon">
                        <input
                          type="text"
                          name="phone"
                          placeholder="Votre numéro de téléphone"
                          value={this.state.phone}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="input-item input-item-textarea ltn__custom-icon">
                    <textarea
                      name="message"
                      placeholder="Votre message"
                      value={this.state.message}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                  <p>
                    <label className="input-info-save mb-0">
                      <input
                        type="checkbox"
                        name="agree"
                        checked={this.state.agree}
                        onChange={this.handleChange}
                      />{" "}
                      Enregistrer mes informations pour la prochaine fois.
                    </label>
                  </p>
                  <div className="btn-wrapper mt-0">
                    <button
                      className="btn theme-btn-1 btn-effect-1 text-uppercase"
                      type="submit"
                    >
                      Envoyer le message
                    </button>
                  </div>
                  {this.state.responseMessage && (
                    <p
                      className={`form-messege mb-0 mt-20 ${this.state.responseClass}`}
                    >
                      {this.state.responseMessage}
                    </p>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactForm;
